import { BubbleMenu } from "@tiptap/react";
import { useEditorContext } from "../Wysiwyg";
import ToolbarItem from "../toolbar/ToolbarItem";
import ToolbarDivider from "../toolbar/ToolbarDivider";

const TableBubbleMenu = () => {
  const { editor } = useEditorContext();

  if (!editor?.isEditable) {
    return null;
  }

  return (
    <BubbleMenu
      editor={editor}
      shouldShow={(state) => state.editor.isActive("table")}
      tippyOptions={{ placement: "top" }}
      className="tiptap-bubble-menu"
    >
      <div
        className="d-flex align-items-center bg-white"
        style={{
          padding: "1px 3px",
          border: "1px solid #ccc",
          boxShadow: "0 2px 4px rgba(0,0,0,.15)",
        }}
      >
        <ToolbarItem
          id="table-bubble-column-before"
          tooltip="Oszlop beszúrása balra"
          onToggle={() => editor.chain().focus().addColumnBefore().run()}
          icon={
            <i
              className="fa fa-diagram-next"
              style={{ transform: "rotate(90deg)" }}
              aria-hidden="true"
            />
          }
        />
        <ToolbarItem
          id="table-bubble-column-after"
          tooltip="Oszlop beszúrása jobbra"
          onToggle={() => editor.chain().focus().addColumnAfter().run()}
          icon={
            <i
              className="fa fa-diagram-next"
              style={{ transform: "rotate(-90deg)" }}
              aria-hidden="true"
            />
          }
        />
        <ToolbarItem
          id="table-bubble-row-before"
          tooltip="Sor beszúrása felfelé"
          onToggle={() => editor.chain().focus().addRowBefore().run()}
          icon={
            <i
              className="fa fa-diagram-next"
              style={{ transform: "rotate(180deg)", marginBottom: "3px" }}
              aria-hidden="true"
            />
          }
        />
        <ToolbarItem
          id="table-bubble-row-after"
          tooltip="Sor beszúrása lefelé"
          onToggle={() => editor.chain().focus().addRowAfter().run()}
          icon={
            <i
              className="fa fa-diagram-next"
              aria-hidden="true"
              style={{ marginTop: "3px" }}
            />
          }
        />

        <ToolbarDivider length="22px" />

        <ToolbarItem
          id="table-bubble-toggle-header"
          tooltip="Fejléc ki/be"
          onToggle={() => editor.chain().focus().toggleHeaderCell().run()}
          icon={<i className="fa fa-heading" aria-hidden="true" />}
        />

        {editor.can().mergeCells() && (
          <ToolbarItem
            id="table-bubble-merge-cells"
            tooltip="Cellák egyesítése"
            onToggle={() => editor.chain().focus().mergeCells().run()}
            icon={<i className="fa fa-code-merge" aria-hidden="true" />}
          />
        )}

        {editor.can().splitCell() && (
          <ToolbarItem
            id="table-bubble-split-cells"
            tooltip="Cellák felosztása"
            onToggle={() => editor.chain().focus().splitCell().run()}
            icon={<i className="fas fa-hand-scissors" aria-hidden="true" />}
          />
        )}

        <ToolbarDivider length="22px" />

        <ToolbarItem
          id="table-bubble-delete-column"
          tooltip="Oszlop törlése"
          onToggle={() => editor.chain().focus().deleteColumn().run()}
          icon={
            <StrikedIcon rotationDegrees={-45}>
              <i className="fa fa-grip-lines-vertical" aria-hidden="true" />
            </StrikedIcon>
          }
        />
        <ToolbarItem
          id="table-bubble-delete-row"
          tooltip="Sor törlése"
          onToggle={() => editor.chain().focus().deleteRow().run()}
          icon={
            <StrikedIcon rotationDegrees={-35} length="15px">
              <i className="fa fa-grip-lines" aria-hidden="true" />
            </StrikedIcon>
          }
        />

        <ToolbarItem
          id="table-bubble-delete-table"
          tooltip="Táblázat törlése"
          onToggle={() => editor.chain().focus().deleteTable().run()}
          icon={<i className="fa fa-trash-can" aria-hidden="true" />}
        />
      </div>
    </BubbleMenu>
  );
};

const StrikedIcon = ({ children, rotationDegrees, length = "17px" }) => {
  return (
    <span style={{ position: "relative" }}>
      {children}
      <div
        style={{
          position: "absolute",
          height: length,
          width: "2px",
          borderLeft: "1px solid white",
          borderRadius: "4px",
          left: "50%",
          transform: `translateX(-50%) rotate(${rotationDegrees}deg)`,
          top: "3px",
          backgroundColor: "#263238",
        }}
      />
    </span>
  );
};

export default TableBubbleMenu;
